import { brand, ThemeOption } from '@helpers/brand';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div ``;
const List = styled.ul `
  display: flex;
  gap: 8px;

  @media ${from(Device.TabletLarge)} {
    gap: 16px;
  }
`;
const Item = styled.li ``;
const Link = styled.a `
  display: block;
  background-color: ${brand.lightGrey};
  border-radius: 6px;
  color: currentColor;
  padding: 12px 16px;
  text-decoration: none;

  &[data-dark-bg='true'] {
    background-color: #000000;
  }

  [data-theme=${ThemeOption.DarkCoral}] & {
    &[data-dark-bg='false'] {
      background-color: ${brand.white};
    }
  }

  [data-size='large'] & {
    display: flex;
    align-items: center;
    height: 100%;
  }

  a&:focus,
  a&:hover {
    outline: auto;
    outline-offset: 3px;
  }

  @media ${until(Device.MobileLarge)} {
    padding: 12px;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 16px 32px;

    a&:focus,
    a&:hover {
      outline-offset: 5px;
    }
  }

  [data-size='medium'] & {
	@media ${from(Device.TabletLarge)} {
      padding: 12px 20px;
    }
  }
`;
const LogoWrapper = styled.span `
  max-width: 140px;
`;
const Logo = styled.img `
  max-height: 48px;
  object-fit: contain;

  [data-size='medium'] & {
    max-height: 70px;

    @media ${until(Device.MobileLarge)} {
      max-height: 70px;
    }
  }

  [data-size='large'] & {
    max-height: 138px;

    @media ${until(Device.MobileLarge)} {
      max-height: 128px;
    }
  }
`;
const AccreditationsStyles = {
    Container,
    Item,
    Link,
    List,
    LogoWrapper,
    Logo,
};
export default AccreditationsStyles;
